[
  {
    "id": "berakhot",
    "name": "ברכות",
    "first": 2,
    "last": 64,
    "volume": 1
  },
  {
    "id": "shabbat",
    "name": "שבת",
    "first": 2,
    "last": 157,
    "volume": 2
  },
  {
    "id": "eruvin",
    "name": "עירובין",
    "first": 2,
    "last": 105,
    "volume": 3
  },
  {
    "id": "pesachim",
    "name": "פסחים",
    "first": 2,
    "last": 121,
    "volume": 4
  },
  {
    "id": "yoma",
    "name": "יומא",
    "first": 2,
    "last": 88,
    "volume": 5
  },
  {
    "id": "sukkah",
    "name": "סוכה",
    "first": 2,
    "last": 56,
    "volume": 6
  },
  {
    "id": "beitzah",
    "name": "ביצה",
    "first": 2,
    "last": 40,
    "volume": 7
  },
  {
    "id": "rosh-hashanah",
    "name": "ראש השנה",
    "first": 2,
    "last": 35,
    "volume": 7
  },
  {
    "id": "taanit",
    "name": "תענית",
    "first": 2,
    "last": 31,
    "volume": 8
  },
  {
    "id": "megillah",
    "name": "מגילה",
    "first": 2,
    "last": 32,
    "volume": 8
  },
  {
    "id": "moed-katan",
    "name": "מועד קטן",
    "first": 2,
    "last": 29,
    "volume": 9
  },
  {
    "id": "chagigah",
    "name": "חגיגה",
    "first": 2,
    "last": 27,
    "volume": 9
  },
  {
    "id": "yevamot",
    "name": "יבמות",
    "first": 2,
    "last": 122,
    "volume": 10
  },
  {
    "id": "ketubot",
    "name": "כתובות",
    "first": 2,
    "last": 112,
    "volume": 11
  },
  {
    "id": "nedarim",
    "name": "נדרים",
    "first": 2,
    "last": 91,
    "volume": 12
  },
  {
    "id": "nazir",
    "name": "נזיר",
    "first": 2,
    "last": 66,
    "volume": 13
  },
  {
    "id": "sotah",
    "name": "סוטה",
    "first": 2,
    "last": 49,
    "volume": 13
  },
  {
    "id": "gittin",
    "name": "גיטין",
    "first": 2,
    "last": 90,
    "volume": 14
  },
  {
    "id": "kiddushin",
    "name": "קידושין",
    "first": 2,
    "last": 82,
    "volume": 15
  },
  {
    "id": "bava-kamma",
    "name": "בבא קמא",
    "first": 2,
    "last": 119,
    "volume": 16
  },
  {
    "id": "bava-metzia",
    "name": "בבא מציעא",
    "first": 2,
    "last": 119,
    "volume": 17
  },
  {
    "id": "bava-batra",
    "name": "בבא בתרא",
    "first": 2,
    "last": 176,
    "volume": 18
  },
  {
    "id": "sanhedrin",
    "name": "סנהדרין",
    "first": 2,
    "last": 113,
    "volume": 19
  },
  {
    "id": "makkot",
    "name": "מכות",
    "first": 2,
    "last": 24,
    "volume": 20
  },
  {
    "id": "shevuot",
    "name": "שבועות",
    "first": 2,
    "last": 49,
    "volume": 20
  },
  {
    "id": "avodah-zarah",
    "name": "עבודה זרה",
    "first": 2,
    "last": 76,
    "volume": 21
  },
  {
    "id": "horayot",
    "name": "הוריות",
    "first": 2,
    "last": 14,
    "volume": 21
  },
  {
    "id": "zevachim",
    "name": "זבחים",
    "first": 2,
    "last": 120,
    "volume": 22
  },
  {
    "id": "menachot",
    "name": "מנחות",
    "first": 2,
    "last": 110,
    "volume": 23
  },
  {
    "id": "chullin",
    "name": "חולין",
    "first": 2,
    "last": 142,
    "volume": 24
  },
  {
    "id": "bekhorot",
    "name": "בכורות",
    "first": 2,
    "last": 61,
    "volume": 25
  },
  {
    "id": "arakhin",
    "name": "ערכין",
    "first": 2,
    "last": 34,
    "volume": 25
  },
  {
    "id": "temurah",
    "name": "תמורה",
    "first": 2,
    "last": 34,
    "volume": 26
  },
  {
    "id": "keritot",
    "name": "כריתות",
    "first": 2,
    "last": 28,
    "volume": 26
  },
  {
    "id": "meilah",
    "name": "מעילה",
    "first": 2,
    "last": 22,
    "volume": 26
  },
  {
    "id": "tamid",
    "name": "תמיד",
    "first": 25,
    "last": 33,
    "volume": 26
  },
  {
    "id": "niddah",
    "name": "נדה",
    "first": 2,
    "last": 73,
    "volume": 27
  }
]